import ChangedBlock from "./ChangedBlock.vue"

export default function install(Vue) {
  Vue.component(ChangedBlock.name, ChangedBlock)
}
